import { PropsWithChildren } from 'react';
import { useRouter } from 'next/router';
import { useResponsive } from '@release/shared/hooks/useResponsive';
import ContentLoader from 'react-content-loader';
import { useAuth0 } from '@auth0/auth0-react';

import { SkeletonRect } from '@/components/skeleton/SkeletonRect';
import { isRealtorBottomTabPath } from '@/utils/paths';

type AnkenSkeletonContainerProps = PropsWithChildren;

export const AnkenSkeletonContainer: React.FC<AnkenSkeletonContainerProps> = ({ children }) => {
  const router = useRouter();
  const { isAuthenticated } = useAuth0();
  const { isDesktop, isReady } = useResponsive();
  const withBottomTab = isReady && !isDesktop && isRealtorBottomTabPath(router.pathname);
  if (isAuthenticated) {
    return (
      <>
        <div className="relative mx-auto w-full max-w-screen-tab">{children}</div>
        {withBottomTab && (
          <div className="fixed bottom-0 z-10 w-full max-w-screen-tab border-t border-e-sem-l-divider-medium bg-sem-l-surf-primary">
            <SkeletonRect className="h-[var(--bottom-tab-height)] w-full px-14 py-2" />
          </div>
        )}
      </>
    );
  }
  if (!isReady) {
    return null;
  }
  return (
    <div className="flex min-h-screen w-full bg-prim-coolgray-10">
      {isDesktop && (
        <div className="flex h-full min-h-screen w-60 flex-col justify-between bg-sem-l-surf-primary p-4">
          <ContentLoader viewBox="0 0 240 480" backgroundColor="#DFF0F5" foregroundColor="#EBF4F4" speed={0.5}>
            <rect x="0" y="0" rx="8" ry="8" width="240" height="88" />
            <rect x="0" y="144" rx="8" ry="8" width="240" height="48" />
            <rect x="0" y="208" rx="8" ry="8" width="240" height="48" />
            <rect x="0" y="272" rx="8" ry="8" width="240" height="48" />
            <rect x="0" y="336" rx="8" ry="8" width="240" height="48" />
          </ContentLoader>
          <ContentLoader viewBox="0 0 240 48" backgroundColor="#DFF0F5" foregroundColor="#EBF4F4" speed={0.5}>
            <rect x="0" y="0" rx="8" ry="8" width="240" height="48" />
          </ContentLoader>
        </div>
      )}
      <div className="relative mx-auto w-full max-w-screen-tab bg-sem-l-surf-primary">{children}</div>
      {withBottomTab && (
        <div className="fixed bottom-0 z-10 w-full max-w-screen-tab border-t border-e-sem-l-divider-medium bg-sem-l-surf-primary">
          <SkeletonRect className="h-[var(--bottom-tab-height)] w-full px-14 py-2" />
        </div>
      )}
    </div>
  );
};
